import { VehicleList } from "./VehicleList";

export function SimulatorsList() {
  return <VehicleList resource="simulators" />;
}
